import { Impression, Event, ButtonEvent, ButtonImpression } from './types';
import { ProductImpressionsEvent } from '@nykaa/utils/retina/types/Retina';
import {
  PRODUCT_CARD_CLICKED,
  IMPRESSION_TYPE,
  PRODUCT_IMPRESSION_EVENT,
} from '@nykaa/utils/retina/constants';
import {
  BANNER_CLICK_EVENT,
  BANNER_IMPRESSION_EVENT,
  BUTTON_CLICK,
  BUTTON_IMPRESSION,
  IMPRESSION,
  CLICK,
} from './constants';
import { pushData, pushEvent } from '@nykaa/data-layer';
import { getWidgetTrackingValues } from 'components/CartOperations/helper';

export const buttonFilterData = (impression: ButtonImpression) => ({
  button_text: impression?.button_text,
  button_position:
    impression?.button_position && impression?.button_position - 1,
  button_status: impression?.button_status || false,
  button_type: impression?.button_type || '',
  widget_filters_all: impression?.widget_filters_all || {},
  widget_filters_selected: impression?.widget_filters_selected || {},
});
export const getCommonEventData = (impression: Impression) => {
  const event: Event = {
    page_name: impression.pageName || '',
    dn_page_type: impression.namespace0,
    dn_page_section: impression.namespace1,
    dn_tile_id: impression.namespace2,
    dn_inventory_position: impression.position1 - 1,
    dn_tile_position: impression.position2 - 1,
    dn_transaction_id: impression.transaction_id,
    dn_wtype: impression.wtype,
    dn_wtype_version: impression.wtype_version,
    dn_brand_ids: impression.brand_ids as any[],
    dn_tracking_metadata: impression.dn_tracking_metadata,
    dn_request_page_data: impression.pageData1 || '',
    dn_inventory_page_data: impression.pageData2 || '',
    hit_recorded_at: impression.timestamp || new Date().getTime() / 1000,
    dn_tile_lang: impression.lang || 'en',
    event_type: '',
    event_name: '',
    dn_ad_type: impression.ad_type,
    dn_video_ad_type: impression.video_ad_type,
    dn_video_total_duration: impression.video_total_duration,
    dn_video_view_duration: impression.video_view_duration,
  };
  return event;
};

// impressions: any[] :- any because it can consume different impressions like ( PRODUCT | BANNER )
export const getImpressionEventData = (
  impression: any,
  impressionType: string
) => {
  const isWidgetButton = !!impression?.button_type;
  // Button Impression
  if (isWidgetButton) {
    const buttonImpressionEvent: ButtonEvent = {
      ...getCommonEventData(impression),
      ...buttonFilterData(impression),
      event_type: IMPRESSION,
      event_name: BUTTON_IMPRESSION,
    };
    return buttonImpressionEvent;
  }
  // Impression type is product
  if (impressionType === IMPRESSION_TYPE.PRODUCT) {
    const productImpressionEvent: ProductImpressionsEvent = {
      ...impression,
      event_type: IMPRESSION,
      event_name: PRODUCT_IMPRESSION_EVENT,
    };
    return productImpressionEvent;
  }

  // Default case, when no type is passed
  const event: Event = {
    ...getCommonEventData(impression),
    event_type: IMPRESSION,
    event_name: BANNER_IMPRESSION_EVENT,
    dn_impression_version: impression.event.indexOf('v2') === -1 ? 'v1' : 'v2',
  };

  return event;
};
/**
 * Reason for putting any type impression have changing nature of values based on the
 * different type of the events
 */
export const getClickEventData = (impression: any) => {
  // event_name is product_card_clicked
  if (impression.event_name === PRODUCT_CARD_CLICKED) {
    const event: Impression | ProductImpressionsEvent = {
      ...impression,
      hit_recorded_at: impression.timestamp || new Date().getTime() / 1000,
    };
    return event;
  }
  // Button Event
  const isWidgetButton = !!impression?.button_type;
  if (isWidgetButton) {
    const buttonImpressionEvent: ButtonEvent = {
      ...getCommonEventData(impression),
      ...buttonFilterData(impression),
      event_type: CLICK,
      event_name: BUTTON_CLICK,
    };
    return buttonImpressionEvent;
  }
  // Default case
  const event: Event = {
    ...getCommonEventData(impression),
    event_type: CLICK,
    event_name: impression.event_name || BANNER_CLICK_EVENT,
  };

  return event;
};

export const pushEventDataLayer = (
  clickEventData: Impression | Event | ProductImpressionsEvent
) => {
  const eventName = clickEventData.event_name;
  const { siteNavigation, siteSubNavigation } =
    getWidgetTrackingValues(clickEventData);
  if (eventName === BANNER_CLICK_EVENT) {
    pushEvent(eventName, {
      bannerProperties: clickEventData,
    });
  }
  pushData({
    siteNavigation,
    siteSubNavigation,
  });
};
